import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgFile } from "./Pic";

export const Lightbox = ({ items, index, setIndex }) => {
  const open = index !== null;
  const count = items.length;
  const next = () => setIndex((i) => (i + 1) % count);
  const prev = () => setIndex((i) => (i - 1 + count) % count);

  useEffect(() => {
    if (!open) return undefined;
    window.__lenis?.stop();
    const onKey = (e) => {
      if (e.key === "Escape") setIndex(null);
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % count);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + count) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.__lenis?.start();
    };
  }, [open, count, setIndex]);

  const item = open ? items[index] : null;
  const btn = "grid h-12 w-12 place-items-center rounded-full border border-white/20 bg-ink/70 text-white transition-colors hover:border-terra hover:bg-terra-deep";

  return (
    <AnimatePresence>
      {open && (
        <motion.div role="dialog" aria-modal="true" aria-label="Bildansicht" className="fixed inset-0 z-[80] bg-ink/95 backdrop-blur-md"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setIndex(null)} data-testid="lightbox">
          <AnimatePresence initial={false}>
            <motion.div key={index} className="absolute inset-0 flex items-center justify-center px-4 pb-28 pt-20 sm:px-24"
              initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }}>
              <img src={imgFile(item.img)} alt={item.alt} className="max-h-full max-w-full object-contain shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="lightbox-image" />
            </motion.div>
          </AnimatePresence>
          <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-4 px-5 pb-6 sm:px-10" onClick={(e) => e.stopPropagation()}>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">{item.cat} · {item.place} · {index + 1}/{count}</p>
              <p className="mt-1 font-display text-2xl font-bold uppercase text-white sm:text-3xl">{item.title}</p>
            </div>
            <div className="flex gap-2">
              <button type="button" onClick={prev} className={btn} aria-label="Vorheriges Bild" data-testid="lightbox-prev"><ChevronLeft size={20} /></button>
              <button type="button" onClick={next} className={btn} aria-label="Nächstes Bild" data-testid="lightbox-next"><ChevronRight size={20} /></button>
            </div>
          </div>
          <button type="button" onClick={() => setIndex(null)} className={`absolute right-5 top-5 ${btn}`} aria-label="Schließen" data-testid="lightbox-close"><X size={20} /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
